import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import { TEXTS } from "../constants";
import logoSvg from "../assets/dark-logo.svg";
import { Navigation } from "../components/navigation";

const PageWrapper = styled.div`
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background: linear-gradient(135deg, #0f1729 0%, #1a2744 50%, #0d1321 100%);
  text-align: center;
  position: relative;
  overflow: hidden;

  /* Grid pattern on dark background */
  &::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: linear-gradient(
        rgba(59, 130, 246, 0.08) 1px,
        transparent 1px
      ),
      linear-gradient(90deg, rgba(59, 130, 246, 0.08) 1px, transparent 1px);
    background-size: 50px 50px;
    pointer-events: none;
  }
`;

const DecorativeCircle = styled.div`
  position: fixed;
  pointer-events: none;
  border-radius: 50%;

  &.circle1 {
    top: -100px;
    right: -100px;
    width: 400px;
    height: 400px;
    background: radial-gradient(
      circle,
      rgba(59, 130, 246, 0.15) 0%,
      transparent 70%
    );
  }

  &.circle2 {
    bottom: -150px;
    left: -100px;
    width: 500px;
    height: 500px;
    background: radial-gradient(
      circle,
      rgba(99, 102, 241, 0.1) 0%,
      transparent 70%
    );
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const Logo = styled.img`
  height: 44px;
  margin-bottom: 32px;
  position: relative;
  z-index: 1;
`;

const ErrorCode = styled.h1`
  font-size: 6rem;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: #3b82f6;
  margin: 0;
  line-height: 1;
  position: relative;
  z-index: 1;
  text-shadow: 0 0 40px rgba(59, 130, 246, 0.3);

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 4rem;
  }
`;

const Title = styled.h2`
  font-size: 1.375rem;
  color: #ffffff;
  margin: 16px 0 8px;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  position: relative;
  z-index: 1;
`;

const Description = styled.p`
  color: rgba(255, 255, 255, 0.6);
  font-size: 0.9375rem;
  max-width: 360px;
  margin: 0 auto 28px;
  line-height: 1.5;
  position: relative;
  z-index: 1;
`;

const HomeLink = styled(Link)`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: ${({ theme }) => theme.colors.primary};
  color: white;
  border-radius: ${({ theme }) => theme.borderRadius.sm};
  text-decoration: none;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  font-size: 0.9375rem;
  box-shadow: ${({ theme }) => theme.shadows.button};
  transition: all ${({ theme }) => theme.transitions.normal};
  position: relative;
  z-index: 1;

  &:hover {
    background: ${({ theme }) => theme.colors.primaryHover};
    box-shadow: ${({ theme }) => theme.shadows.buttonHover};
    color: white;
    text-decoration: none;
  }
`;

function NotFoundPage() {
  return (
    <>
      <Navigation showBack={true} />
      <PageWrapper>
        <DecorativeCircle className="circle1" />
        <DecorativeCircle className="circle2" />

        <Logo src={logoSvg} alt="DevCraft" />

        <ErrorCode>404</ErrorCode>

        <Title>{TEXTS.NOT_FOUND.TITLE}</Title>

        <Description>{TEXTS.NOT_FOUND.MESSAGE}</Description>

        <HomeLink to="/">{TEXTS.NOT_FOUND.GO_HOME}</HomeLink>
      </PageWrapper>
    </>
  );
}

export default NotFoundPage;
